export default [
  {
    path: '/configuracion/mantenimiento/empresas',
    name: 'empresas',
    component: () => import('@/views/configuracion/mantenimiento/empresas.vue'),
    meta: {
      pageTitle: 'Listar Empresas',
      breadcrumb: [
        {
          text: 'Empresas',
        },
        {
          text: 'Listar Empresas',
          active: true,
        },
      ],
      resource: 'Empresas',
      action: 'menu',
    },
  },

  {
    path: '/configuracion/mantenimiento/fundos',
    name: 'fundos',
    component: () => import('@/views/configuracion/mantenimiento/fundos.vue'),
    meta: {
      pageTitle: 'Listar Fundos',
      breadcrumb: [
        {
          text: 'Fundos',
        },
        {
          text: 'Listar Fundos',
          active: true,
        },
      ],
      resource: 'Fundos',
      action: 'menu',
    },
  },

  {
    path: '/configuracion/mantenimiento/etapas',
    name: 'etapas',
    component: () => import('@/views/configuracion/mantenimiento/etapas.vue'),
    meta: {
      pageTitle: 'Listar Etapas',
      breadcrumb: [
        {
          text: 'Etapas',
        },
        {
          text: 'Listar Etapas',
          active: true,
        },
      ],
      resource: 'Etapas',
      action: 'menu',
    },
  },

  {
    path: '/configuracion/usuarios',
    name: 'usuarios',
    component: () => import('@/views/configuracion/mantenimiento/etapas.vue'),
    meta: {
      pageTitle: 'Listar Usuarios',
      breadcrumb: [
        {
          text: 'Usuarios',
        },
        {
          text: 'Listar Usuarios',
          active: true,
        },
      ],
      resource: 'Usuarios',
      action: 'menu',
    },
  },

  {
    path: '/configuracion/mantenimiento/evaluador',
    name: 'evaluadorce',
    component: () => import('@/views/configuracion/mantenimiento/liderazgo_evaluador.vue'),
    meta: {
      pageTitle: 'Liderazgo Evaluadores',
      breadcrumb: [
        {
          text: 'Evaluadores',
        },
        {
          text: 'Liderazgo Evaluadores',
          active: true,
        },
      ],
      resource: 'Evaluador CE',
      action: 'menu',
    },
  },
]
